package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed class NonceRequestResult {
    @Serializable
    class Invalid(
        @SerialName("message") val message: String? = null,
        @SerialName("responseCode") val responseCode: String? = null
    ) : NonceRequestResult()

    @Serializable
    @SerialName("device_pending")
    class Pending(
        @SerialName("pin") val pin: String,
        @SerialName("registrationUrl") val url: String,
    ) : NonceRequestResult() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("device_already_registered")
    class AlreadyRegistered(@SerialName("message") val message: String) : NonceRequestResult() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    class Error(val message: String) : NonceRequestResult()

    class RetryFailed : NonceRequestResult()

    fun <R> fold(
        onInvalid: (Invalid: Invalid) -> R,
        onPending: (Pending: Pending) -> R,
        onAlreadyRegistered: (AlreadyRegistered: AlreadyRegistered) -> R,
        onError: (Error: Error) -> R,
        onRetryFailed: (RetryFailed: RetryFailed) -> R
    ): R {
        return when (this) {
            is Invalid -> onInvalid(Invalid(this.message, this.responseCode))
            is Pending -> onPending(Pending(this.pin, this.url))
            is AlreadyRegistered -> onAlreadyRegistered(AlreadyRegistered(this.message))
            is Error -> onError(Error(this.message))
            is RetryFailed -> onRetryFailed(RetryFailed())
        }
    }
}